import { render } from "./InquiryCheck.vue?vue&type=template&id=ebd86740&scoped=true&ts=true"
import script from "./InquiryCheck.vue?vue&type=script&lang=ts"
export * from "./InquiryCheck.vue?vue&type=script&lang=ts"

import "./InquiryCheck.vue?vue&type=style&index=0&id=ebd86740&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd86740"]])

export default __exports__